import React, { createContext, useState, useEffect, useContext } from 'react';
import { authApiClient } from '../api/apiClient';
import LoadingSpinner from '../opencomponents/LoadingSpinner'; 

// 1. 创建 Context
const AuthContext = createContext(null);

// 2. 创建 Provider 组件
export function AuthProvider({ children }) {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true); // 用于处理初始加载状态

    // 在应用加载时，只检查一次用户登录状态
    useEffect(() => {
        const checkUserSession = async () => {
            try {
                // 使用我们统一的验证接口
                const response = await authApiClient.get('/auth/profile');
                setUser(response.data.user);
            } catch (error) {
                console.log("No active session found.");
                setUser(null);
            } finally {
                setLoading(false);
            }
        };
        checkUserSession();
    }, []);

    // 登录函数，让 Login 组件调用
    const handleLoginSuccess = (userData) => {
        setUser(userData);
    };

    // 登出函数
    const handleLogout = async () => {
        try {
            await authApiClient.post('/auth/logout');
        } catch (error) {
            console.error('Logout failed:', error);
        } finally {
            setUser(null);
        }
    };

    // 新增：更新用户信息函数
    const updateUserProfile = (updatedUserData) => {
        setUser(updatedUserData);
    };
    
    // 将 user, loading, 和操作函数通过 value 传递下去
    const value = {
        user,
        loading,
        onLoginSuccess: handleLoginSuccess,
        onLogout: handleLogout,
        updateUserProfile,
    };

    // 如果还在加载中，可以显示一个全局的 loading 画面，或者什么都不显示
    if (loading) {
        return  <LoadingSpinner />;
    }

    return (
        <AuthContext.Provider value={value}>
            {children}
        </AuthContext.Provider>
    );
}

// 3. 创建一个自定义 Hook，方便其他组件使用 Context
export function useAuth() {
    return useContext(AuthContext);
}
